var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707891;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.133,2.578H27.586V0H25.008V2.578H7.992V0H5.414V2.578H3.867A3.872,3.872,0,0,0,0,6.445V29.133A3.872,3.872,0,0,0,3.867,33H29.133A3.872,3.872,0,0,0,33,29.133V6.445A3.872,3.872,0,0,0,29.133,2.578Zm1.289,26.555a1.291,1.291,0,0,1-1.289,1.289H3.867a1.291,1.291,0,0,1-1.289-1.289V12.117H30.422Zm0-19.594H2.578V6.445A1.291,1.291,0,0,1,3.867,5.156H5.414V7.734H7.992V5.156H25.008V7.734h2.578V5.156h1.547a1.291,1.291,0,0,1,1.289,1.289Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.898 14.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 2,
    transform: "translate(0.102 0.176)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.055 14.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 2,
    transform: "translate(-0.055 0.176)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.211 14.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 2,
    transform: "translate(-0.211 0.176)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.367 14.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 2,
    transform: "translate(-0.367 0.176)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.523 14.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 2,
    transform: "translate(0.477 0.176)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.898 19.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 3,
    transform: "translate(0.102 0.02)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.055 19.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(-0.055 0.02)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.211 19.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(-0.211 0.02)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.367 19.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(-0.367 0.02)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.898 25.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 3,
    transform: "translate(0.102 -0.137)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.055 25.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(-0.055 -0.137)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.211 25.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(-0.211 -0.137)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.367 25.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(-0.367 -0.137)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.523 19.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 3,
    transform: "translate(0.477 0.02)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.1d943137.svg";
export { ForwardRef as ReactComponent };